const questionServiceName = "/Question";

export function questionService (http)  {
    return {
        getAllQuestionTypes: () => {            
            return http.get(questionServiceName + '/GetAllQuestionTypes');
        },
        getTargetQuestion: (userProfileId, questionId) => {
            let parameters = {
                userId: userProfileId,
                Id: questionId
            }
            debugger;
            return http.post(questionServiceName + '/GetTargetQuestion', parameters);
        },
        saveSurveyQuestionsFromFileAsync: async paramterContainer => {
            let parameters = {
                fileId: paramterContainer.fileId,
                filename: paramterContainer.filename,
                fileType: paramterContainer.fileType,
                firstHeaderBoxTitle: paramterContainer.firstHeaderBoxTitle,
                secondHeaderBoxTitle: paramterContainer.secondHeaderBoxTitle,
                fileColumnOrder: paramterContainer.fileColumnOrder,
                dateRangeFrom: paramterContainer.dateRangeFrom,
                dateRangeTo: paramterContainer.dateRangeTo,
                lineFrom: paramterContainer.lineFrom,
                lineTo: paramterContainer.lineTo,
                sheetNo: paramterContainer.sheetNo,
                multiAnser: paramterContainer.multiAnser,
                questionTypeId: paramterContainer.questionTypeId
            }
            return await http.post(questionServiceName + '/SaveSurveyQuestionsFromFileAsync', parameters);
        },
        getQuestionByHeader: questionHeaderId => {
            let parameters = {
                questionHeaderId
            }
            return http.post(questionServiceName + '/GetQuestionByHeader', parameters);
        },
        getQuestionByDetail: questionDetailId => {
            let parameters = {
                questionDetailId
            }
            return http.post(questionServiceName + '/GetQuestionByDetail', parameters);
        }        

    }
}